import React from 'react';
import FormWrapper from '../../../BaseModule/Components/Form/FormWrapper';
import InputField from '../../../BaseModule/Components/Form/Components/InputField';
import PhoneNumberField from '../../../BaseModule/Components/Form/Components/PhoneNumber/PhoneNumberField';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import SubmitButton from '../../../BaseModule/Components/Button/SubmitButton';
import useTranslation from '../../../../Hooks/useTranslation';
import apiClient from '../../../../Services/ApiClient';
import useNotification from '../../../../Hooks/useNotification';

interface Props {
	onSuccess: () => void;
}

const ContactMyDoctor: React.FC<Props> = ({ onSuccess }) => {
	const { t } = useTranslation();
	const { showNotificationSuccess } = useNotification();

	const validationSchema = yup.object({
		name: yup.string().required(t('validation.contactMyDoctor.name')),
		city: yup.string().required(t('validation.contactMyDoctor.city')),
		phoneNumber: yup
			.string()
			.required(t('validation.contactMyDoctor.phoneNumber')),
	});

	const formMethods = useForm({
		defaultValues: {},
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: any) => {
		const result = await apiClient.post('/zadej-lekare', values);
		if (result.status === 201) {
			showNotificationSuccess({
				content: t('component.contactMyDoctor.createdMessage'),
			});
		}
		onSuccess();
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<div className='mb-3'>
				<InputField
					name='name'
					label='component.contactMyDoctor.name'
					placeholder='component.contactMyDoctor.namePlaceholder'
					isRequired
				/>
			</div>
			<div className='mb-3'>
				<InputField
					name='city'
					label='component.contactMyDoctor.city'
					placeholder='component.contactMyDoctor.cityPlaceholder'
					isRequired
				/>
			</div>
			<div className='mb-3'>
				<PhoneNumberField
					name='phoneNumber'
					label='component.contactMyDoctor.phoneNumber'
					placeholder='component.contactMyDoctor.phoneNumberPlaceholder'
					isRequired
				/>
			</div>
			<SubmitButton
				className='btn btn-submit w-100'
				title='component.contactMyDoctor.send'
				onSubmit={handleSubmit}
			/>
		</FormWrapper>
	);
};

export default ContactMyDoctor;
